export enum DictionariesStorageKey {
  DICTIONARY = 'dictionary',
}
